import { toNumber } from '@shared/datastore/core';
import { CurrencyApi } from 'api-typings/common/common';
import { Currency, CurrencyAjax } from './currencies.model';

export function transformCurrency(currency: CurrencyApi): Currency {
  return {
    code: currency.code,
    country: currency.country,
    exchangeRate: currency.exchange_rate,
    id: currency.id,
    name: currency.name,
    sign: currency.sign,
  };
}

export function transformCurrencyAjax(currency: CurrencyAjax): Currency {
  return {
    code: currency.code,
    country: currency.country,
    exchangeRate: toNumber(currency.exchangerate),
    id: toNumber(currency.id),
    name: currency.name,
    sign: currency.sign,
  };
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/currencies/currencies.transformers.ts